import AccountMenu from "./accountmenu/AccountMenu";
import LocationModal from "./location/LocationModal";
import Search from "./search/Search";
import { useAuth } from "../../../context/AuthContext";

const NavbarTwo = () => {
    const { isAuthenticated } = useAuth();
  
  return (
    <>
      <div className=" display-max">
        <nav className="navbar  navbar-expand-md bg-white navbar-custom-two border-bottom z-index-3">
          <div className="container align-custom-center w-100 h-100">
            
            <div className=" w-100">
              <Search />
            </div>
            
          </div>
        </nav>
        <LocationModal/>
      </div>
    </>
  );
};

export default NavbarTwo;
